export class FormatCurrencyHelper {
  public static formatCurrency(value: number, location = 'en-US', currency = 'USD'): string {
    return value.toLocaleString(location, { style: 'currency', currency });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/format-currency-helper.ts